import React, { createRef } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

interface DropDownWithLabelProps {
  className?: string;
  label: string;
  content: { label: string; value: string; code?: string }[];
  displayAttributes?: {
    primary: string,
    secondary: string
  };
  filterFields?: string[];
  selected?: { label: string; value: string };
  handleChange: (value: string) => void;
}

interface DropDownWithLabelState {
  isOpen: boolean;
  selected: any;
  filterValue: any;
}


export default class DropDownWithLabel extends React.PureComponent<DropDownWithLabelProps, DropDownWithLabelState> {
  inputElRef: any;

  readonly state = {
    isOpen: false,
    selected: undefined,
    filterValue: undefined
  };

  constructor(props: any) {
    super(props);

    this.inputElRef = createRef();
  }

  componentDidMount() {
    this.setState({
      selected: this.props.selected
    });
  }

  componentDidUpdate(prevProps: Readonly<DropDownWithLabelProps>) {
    if (prevProps.selected !== this.props.selected) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selected: this.props.selected
      });
    }
  }

  handleChange = (event: any) => {
    const { value } = event.currentTarget;
    const selected = this.props.content.find((c) => c.value === value);
    if (selected) {
      this.props.handleChange(value);
      this.setState({ isOpen: true });
    }

  };

  toggle = (e?: Event | React.SyntheticEvent) => {
    if (document.activeElement && this.state.isOpen) {
      if (document.activeElement.id === 'dropdown-input' && (this.inputElRef as any).current === document.activeElement) return;
    }
    if (this.state.isOpen && this.props.selected) {
      this.inputElRef.current.value = this.props.selected!.label;
    }
    this.setState((prevState: any) => this.setState({ isOpen: !prevState.isOpen }));

  };

  handleFilterValueChange = (v: string) => {
    this.setState({ filterValue: v, selected: v });

  };

  handleInputClear = (e: any) => {
    e.stopPropagation();

    this.setState({ isOpen: true });

    (this.inputElRef as any).current.value = '';
    (this.inputElRef as any).current.focus();

    this.setState({
      filterValue: undefined,
      selected: undefined
    });
  };

  checkItemMatchesFilterValues(obj: any) {
    let fieldsToFilter: string[] = [ 'value' ];
    if (this.props.filterFields) {
      fieldsToFilter = this.props.filterFields;
    }
    let valContained = false;
    fieldsToFilter?.forEach((val) => {
      if (obj[ val ].toLowerCase().includes((this.state.filterValue! as string).toLowerCase())) {
        valContained = true;
      }
    });
    return valContained;
  }

  dropdownContainerClick() {
    (this.inputElRef as any).current.focus();
    this.toggle();
  }

  getSelectedValue() {
    return this.state.selected ? (this.state.selected as any).label : undefined;

  }

  isSelected(value: { label: string; value: string }) {
    return (this.props.selected as any)?.value === value.value;
  }

  getSelectMenuItems(object: { label: string; value: string; code?: string }) {
    return this.props.displayAttributes ?
      <div className={'flex-column'}>
        <div className={'text-bold'}>
          {(object as any)[ this.props.displayAttributes.primary ]}
        </div>
        <div>
          {(object as any)[ this.props.displayAttributes.secondary ]}
        </div>
      </div> :
      <div>
        {object.label}
      </div>;

  }

  getSelectMenu() {
    return this.props.content.filter((obj: {
      value: string;
      label: string
    }) => (this.state.filterValue ? this.checkItemMatchesFilterValues(obj) : true)).map((object: {
      value: string;
      label: string
    }, inx) => (
      <DropdownItem
        className={`dropdown-item ${this.isSelected(object) ? 'selected' : ''}`}
        key={object.value}
        onClick={e => this.handleChange(e)}
        value={object.value}
        autoClose={false}>
        {this.getSelectMenuItems(object)}
      </DropdownItem>
    ));

  }

  getDropDownToggle() {
    return (
      <>
        <input
          value={this.getSelectedValue()}
          onChange={(v) => this.handleFilterValueChange(v.target.value)}
          className={`dropdown-toggle dropdown-input ${this.state.filterValue ? 'filter' : ''}`}
          style={{ opacity: 1 }}
          ref={this.inputElRef}
          autoComplete={'off'}
          id="dropdown-input"
        />
        <div className="dropdown-clear" onClick={(e) => this.handleInputClear(e)}>
        </div>
      </>);
  }

  render() {
    return (
      <div className="d-flex flex-column justify-content-start rates-dropdown"
           onClick={() => this.dropdownContainerClick()}>
        <label className="dropdown-with-label-label">{this.props.label}</label>
        <Dropdown className="dropdown-with-label" inNavbar={false} isOpen={this.state.isOpen}
                  toggle={(e: any) => this.toggle(e)}>
          <DropdownToggle caret nav={false}>
            {this.getDropDownToggle()}
          </DropdownToggle>
          <DropdownMenu tag="ul">
            {this.getSelectMenu()}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}
